/** Defines accessor over property, stores original value in _value Both properties need to be typed * */
export function defineAccessor(target, name, settings, hiddenProps) {
    for (var object = target; (object = Object.getPrototypeOf(object));) {
        var descriptor = Object.getOwnPropertyDescriptor(object, name);
        if (!descriptor)
            continue;
        const prop = '_' + String(name);
        Object.defineProperty(target, name, {
            ...descriptor,
            enumerable: !(hiddenProps === null || hiddenProps === void 0 ? void 0 : hiddenProps.includes(name)),
            ...settings
        });
        Object.defineProperty(target, prop, {
            writable: true,
            enumerable: false
        });
        break;
    }
}
/** Define setter swapping items in collection */
export function defineCollectionAccessor(target, name, collection, settings = {}, hiddenProps) {
    Object.defineProperty(target, name, {
        enumerable: !(hiddenProps === null || hiddenProps === void 0 ? void 0 : hiddenProps.includes(name)),
        get() {
            return collection;
        },
        set(values) {
            return collection.setItems(values || []);
        },
        ...settings
    });
    return collection;
}
/** Implicit params are not overwritable, and are passed from collection dynamically instead* */
export function defineImplicitAccessors(target, getParams, hiddenProps) {
    const params = getParams(target);
    for (let property in params) {
        Object.defineProperty(target, property, {
            get: () => getParams(target)[property],
            set: () => { },
            enumerable: !(hiddenProps === null || hiddenProps === void 0 ? void 0 : hiddenProps.includes(property))
        });
    }
}
//# sourceMappingURL=accessors.js.map